var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"keyboard-help bg-shade-2 absolute z-10 p-4"},[_c('button',{staticClass:"button button--secondary",on:{"click":_vm.focusFirstTreeItem}},[_vm._v(_vm._s(_vm.resources?.SkipToFormList || 'Skip to Form List'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }